import { GetFromScript } from "./script-data.service";

const settings = GetFromScript("store-settings");

export const { StoreId: StoreId } = settings;

export default {
  StoreId,
};
